import DTO from './DTO';

class SettingsDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'settings.key',
      },
      {
        name: 'name_label',
        type: String,
        validators: {},
        labelKey: 'settings.name',
      },
      {
        name: 'group',
        type: String,
        validators: {},
        labelKey: 'settings.group',
      },
      {
        name: 'group_label',
        type: String,
        validators: {},
        labelKey: 'settings.group_label',
      },
      {
        name: 'payload',
        type: String,
        validators: {},
        labelKey: 'settings.value',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default SettingsDTO;
